/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import * as zod from 'zod';


export const TasksListQueryParams = zod.object({
  "car_id": zod.string().uuid().optional().describe('Tasks on this elevator, plus its property\'s tasks with no elevator.'),
  "portfolio": zod.array(zod.string().uuid()).optional().describe('Global portfolio filter: tasks on any of these portfolios.'),
  "portfolio_id": zod.string().uuid().optional(),
  "property_id": zod.string().uuid().optional(),
  "region": zod.array(zod.string()).optional().describe('Global region filter: tasks on properties in any of these regions.')
})

export const TasksListResponseItem = zod.object({
  "id": zod.string().uuid(),
  "displayId": zod.string(),
  "title": zod.string(),
  "category": zod.enum(['general', 'invoice_dispute', 'maintenance', 'compliance', 'contract', 'performance', 'safety', 'commitment_follow_up']).describe('\* `general` - General\n\* `invoice_dispute` - Invoice dispute\n\* `maintenance` - Maintenance\n\* `compliance` - Compliance\n\* `contract` - Contract\n\* `performance` - Performance\n\* `safety` - Safety\n\* `commitment_follow_up` - Commitment follow-up'),
  "status": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal'),
  "position": zod.number(),
  "kind": zod.enum(['open', 'completed', 'canceled']).describe('\* `open` - Open\n\* `completed` - Completed\n\* `canceled` - Canceled')
}).strict(),
  "propertyId": zod.string().uuid(),
  "propertyName": zod.string(),
  "assignee": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdBy": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "followUpDate": zod.string().date().nullable(),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict()),
  "summary": zod.string(),
  "latestUpdate": zod.object({
  "text": zod.string(),
  "createdAt": zod.string().datetime({"offset":true})
}).strict().nullable()
}).strict()
export const TasksListResponse = zod.array(TasksListResponseItem)

export const tasksCreateBodyTitleMax = 200;

export const tasksCreateBodyDescriptionMax = 8000;



export const TasksCreateBody = zod.object({
  "title": zod.string().min(1).max(tasksCreateBodyTitleMax),
  "carIds": zod.array(zod.string().uuid()).optional(),
  "assigneeId": zod.string().uuid().nullish(),
  "followUpDate": zod.string().date().nullish(),
  "propertyId": zod.string().uuid(),
  "description": zod.string().max(tasksCreateBodyDescriptionMax).optional()
})

export const TasksCreateResponse = zod.object({
  "id": zod.string().uuid(),
  "displayId": zod.string(),
  "title": zod.string(),
  "category": zod.enum(['general', 'invoice_dispute', 'maintenance', 'compliance', 'contract', 'performance', 'safety', 'commitment_follow_up']).describe('\* `general` - General\n\* `invoice_dispute` - Invoice dispute\n\* `maintenance` - Maintenance\n\* `compliance` - Compliance\n\* `contract` - Contract\n\* `performance` - Performance\n\* `safety` - Safety\n\* `commitment_follow_up` - Commitment follow-up'),
  "status": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal'),
  "position": zod.number(),
  "kind": zod.enum(['open', 'completed', 'canceled']).describe('\* `open` - Open\n\* `completed` - Completed\n\* `canceled` - Canceled')
}).strict(),
  "propertyId": zod.string().uuid(),
  "propertyName": zod.string(),
  "assignee": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdBy": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "followUpDate": zod.string().date().nullable(),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict()),
  "summary": zod.string(),
  "latestUpdate": zod.object({
  "text": zod.string(),
  "createdAt": zod.string().datetime({"offset":true})
}).strict().nullable(),
  "description": zod.string(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "provider": zod.object({
  "name": zod.string(),
  "contact": zod.string()
}).strict().nullable(),
  "summaryLogCount": zod.number(),
  "substantiveLogCount": zod.number(),
  "publishedAt": zod.string().datetime({"offset":true}).nullable(),
  "publishedLogCount": zod.number(),
  "publishedEntryCount": zod.number(),
  "logs": zod.array(zod.object({
  "id": zod.string().uuid(),
  "kind": zod.enum(['issue_opened', 'update', 'chase_sent', 'provider_update', 'scope_change', 'escalated', 'task_complete', 'resolved', 'status_changed', 'assignee_changed', 'elevators_changed', 'follow_up_changed', 'title_changed', 'description_changed', 'category_changed', 'evidence_added', 'published']).describe('\* `issue_opened` - Issue opened\n\* `update` - Update\n\* `chase_sent` - Chase sent\n\* `provider_update` - Provider update\n\* `scope_change` - Scope change\n\* `escalated` - Escalated\n\* `task_complete` - Task complete\n\* `resolved` - Resolved\n\* `status_changed` - Status changed\n\* `assignee_changed` - Assignee changed\n\* `elevators_changed` - Elevators changed\n\* `follow_up_changed` - Follow-up changed\n\* `title_changed` - Title changed\n\* `description_changed` - Description changed\n\* `category_changed` - Category changed\n\* `evidence_added` - Evidence added\n\* `published` - Published'),
  "label": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal'),
  "position": zod.number()
}).strict().nullable(),
  "text": zod.string(),
  "author": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true})
}).strict()),
  "evidence": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "url": zod.string(),
  "fileType": zod.string(),
  "logId": zod.string().uuid().nullable(),
  "uploadedBy": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true})
}).strict())
}).strict()

export const TasksRetrieveParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this task.')
})

export const TasksRetrieveResponse = zod.object({
  "id": zod.string().uuid(),
  "displayId": zod.string(),
  "title": zod.string(),
  "category": zod.enum(['general', 'invoice_dispute', 'maintenance', 'compliance', 'contract', 'performance', 'safety', 'commitment_follow_up']).describe('\* `general` - General\n\* `invoice_dispute` - Invoice dispute\n\* `maintenance` - Maintenance\n\* `compliance` - Compliance\n\* `contract` - Contract\n\* `performance` - Performance\n\* `safety` - Safety\n\* `commitment_follow_up` - Commitment follow-up'),
  "status": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal'),
  "position": zod.number(),
  "kind": zod.enum(['open', 'completed', 'canceled']).describe('\* `open` - Open\n\* `completed` - Completed\n\* `canceled` - Canceled')
}).strict(),
  "propertyId": zod.string().uuid(),
  "propertyName": zod.string(),
  "assignee": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdBy": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "followUpDate": zod.string().date().nullable(),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict()),
  "summary": zod.string(),
  "latestUpdate": zod.object({
  "text": zod.string(),
  "createdAt": zod.string().datetime({"offset":true})
}).strict().nullable(),
  "description": zod.string(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "provider": zod.object({
  "name": zod.string(),
  "contact": zod.string()
}).strict().nullable(),
  "summaryLogCount": zod.number(),
  "substantiveLogCount": zod.number(),
  "publishedAt": zod.string().datetime({"offset":true}).nullable(),
  "publishedLogCount": zod.number(),
  "publishedEntryCount": zod.number(),
  "logs": zod.array(zod.object({
  "id": zod.string().uuid(),
  "kind": zod.enum(['issue_opened', 'update', 'chase_sent', 'provider_update', 'scope_change', 'escalated', 'task_complete', 'resolved', 'status_changed', 'assignee_changed', 'elevators_changed', 'follow_up_changed', 'title_changed', 'description_changed', 'category_changed', 'evidence_added', 'published']).describe('\* `issue_opened` - Issue opened\n\* `update` - Update\n\* `chase_sent` - Chase sent\n\* `provider_update` - Provider update\n\* `scope_change` - Scope change\n\* `escalated` - Escalated\n\* `task_complete` - Task complete\n\* `resolved` - Resolved\n\* `status_changed` - Status changed\n\* `assignee_changed` - Assignee changed\n\* `elevators_changed` - Elevators changed\n\* `follow_up_changed` - Follow-up changed\n\* `title_changed` - Title changed\n\* `description_changed` - Description changed\n\* `category_changed` - Category changed\n\* `evidence_added` - Evidence added\n\* `published` - Published'),
  "label": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal'),
  "position": zod.number()
}).strict().nullable(),
  "text": zod.string(),
  "author": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true})
}).strict()),
  "evidence": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "url": zod.string(),
  "fileType": zod.string(),
  "logId": zod.string().uuid().nullable(),
  "uploadedBy": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true})
}).strict())
}).strict()

export const TasksPartialUpdateParams = zod.object({
  "id": zod.string().uuid().describe('A UUID string identifying this task.')
})

export const tasksPartialUpdateBodyTitleMax = 200;

export const tasksPartialUpdateBodyDescriptionMax = 8000;



export const TasksPartialUpdateBody = zod.object({
  "title": zod.string().min(1).max(tasksPartialUpdateBodyTitleMax).optional(),
  "carIds": zod.array(zod.string().uuid()).optional(),
  "assigneeId": zod.string().uuid().nullish(),
  "followUpDate": zod.string().date().nullish(),
  "description": zod.string().max(tasksPartialUpdateBodyDescriptionMax).optional(),
  "category": zod.enum(['general', 'invoice_dispute', 'maintenance', 'compliance', 'contract', 'performance', 'safety', 'commitment_follow_up']).optional().describe('\* `general` - General\n\* `invoice_dispute` - Invoice dispute\n\* `maintenance` - Maintenance\n\* `compliance` - Compliance\n\* `contract` - Contract\n\* `performance` - Performance\n\* `safety` - Safety\n\* `commitment_follow_up` - Commitment follow-up'),
  "statusId": zod.string().uuid().optional()
})

export const TasksPartialUpdateResponse = zod.object({
  "id": zod.string().uuid(),
  "displayId": zod.string(),
  "title": zod.string(),
  "category": zod.enum(['general', 'invoice_dispute', 'maintenance', 'compliance', 'contract', 'performance', 'safety', 'commitment_follow_up']).describe('\* `general` - General\n\* `invoice_dispute` - Invoice dispute\n\* `maintenance` - Maintenance\n\* `compliance` - Compliance\n\* `contract` - Contract\n\* `performance` - Performance\n\* `safety` - Safety\n\* `commitment_follow_up` - Commitment follow-up'),
  "status": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal'),
  "position": zod.number(),
  "kind": zod.enum(['open', 'completed', 'canceled']).describe('\* `open` - Open\n\* `completed` - Completed\n\* `canceled` - Canceled')
}).strict(),
  "propertyId": zod.string().uuid(),
  "propertyName": zod.string(),
  "assignee": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdBy": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "followUpDate": zod.string().date().nullable(),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict()),
  "summary": zod.string(),
  "latestUpdate": zod.object({
  "text": zod.string(),
  "createdAt": zod.string().datetime({"offset":true})
}).strict().nullable(),
  "description": zod.string(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "provider": zod.object({
  "name": zod.string(),
  "contact": zod.string()
}).strict().nullable(),
  "summaryLogCount": zod.number(),
  "substantiveLogCount": zod.number(),
  "publishedAt": zod.string().datetime({"offset":true}).nullable(),
  "publishedLogCount": zod.number(),
  "publishedEntryCount": zod.number(),
  "logs": zod.array(zod.object({
  "id": zod.string().uuid(),
  "kind": zod.enum(['issue_opened', 'update', 'chase_sent', 'provider_update', 'scope_change', 'escalated', 'task_complete', 'resolved', 'status_changed', 'assignee_changed', 'elevators_changed', 'follow_up_changed', 'title_changed', 'description_changed', 'category_changed', 'evidence_added', 'published']).describe('\* `issue_opened` - Issue opened\n\* `update` - Update\n\* `chase_sent` - Chase sent\n\* `provider_update` - Provider update\n\* `scope_change` - Scope change\n\* `escalated` - Escalated\n\* `task_complete` - Task complete\n\* `resolved` - Resolved\n\* `status_changed` - Status changed\n\* `assignee_changed` - Assignee changed\n\* `elevators_changed` - Elevators changed\n\* `follow_up_changed` - Follow-up changed\n\* `title_changed` - Title changed\n\* `description_changed` - Description changed\n\* `category_changed` - Category changed\n\* `evidence_added` - Evidence added\n\* `published` - Published'),
  "label": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal'),
  "position": zod.number()
}).strict().nullable(),
  "text": zod.string(),
  "author": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true})
}).strict()),
  "evidence": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "url": zod.string(),
  "fileType": zod.string(),
  "logId": zod.string().uuid().nullable(),
  "uploadedBy": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true})
}).strict())
}).strict()

export const TasksEvidenceCreateParams = zod.object({
  "id": zod.string().uuid().describe('UUID of the task.')
})

export const TasksEvidenceCreateBody = zod.object({
  "attachmentId": zod.string().uuid(),
  "logId": zod.string().uuid().nullish()
})

export const TasksEvidenceCreateResponse = zod.object({
  "id": zod.string().uuid(),
  "displayId": zod.string(),
  "title": zod.string(),
  "category": zod.enum(['general', 'invoice_dispute', 'maintenance', 'compliance', 'contract', 'performance', 'safety', 'commitment_follow_up']).describe('\* `general` - General\n\* `invoice_dispute` - Invoice dispute\n\* `maintenance` - Maintenance\n\* `compliance` - Compliance\n\* `contract` - Contract\n\* `performance` - Performance\n\* `safety` - Safety\n\* `commitment_follow_up` - Commitment follow-up'),
  "status": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal'),
  "position": zod.number(),
  "kind": zod.enum(['open', 'completed', 'canceled']).describe('\* `open` - Open\n\* `completed` - Completed\n\* `canceled` - Canceled')
}).strict(),
  "propertyId": zod.string().uuid(),
  "propertyName": zod.string(),
  "assignee": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdBy": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "followUpDate": zod.string().date().nullable(),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict()),
  "summary": zod.string(),
  "latestUpdate": zod.object({
  "text": zod.string(),
  "createdAt": zod.string().datetime({"offset":true})
}).strict().nullable(),
  "description": zod.string(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "provider": zod.object({
  "name": zod.string(),
  "contact": zod.string()
}).strict().nullable(),
  "summaryLogCount": zod.number(),
  "substantiveLogCount": zod.number(),
  "publishedAt": zod.string().datetime({"offset":true}).nullable(),
  "publishedLogCount": zod.number(),
  "publishedEntryCount": zod.number(),
  "logs": zod.array(zod.object({
  "id": zod.string().uuid(),
  "kind": zod.enum(['issue_opened', 'update', 'chase_sent', 'provider_update', 'scope_change', 'escalated', 'task_complete', 'resolved', 'status_changed', 'assignee_changed', 'elevators_changed', 'follow_up_changed', 'title_changed', 'description_changed', 'category_changed', 'evidence_added', 'published']).describe('\* `issue_opened` - Issue opened\n\* `update` - Update\n\* `chase_sent` - Chase sent\n\* `provider_update` - Provider update\n\* `scope_change` - Scope change\n\* `escalated` - Escalated\n\* `task_complete` - Task complete\n\* `resolved` - Resolved\n\* `status_changed` - Status changed\n\* `assignee_changed` - Assignee changed\n\* `elevators_changed` - Elevators changed\n\* `follow_up_changed` - Follow-up changed\n\* `title_changed` - Title changed\n\* `description_changed` - Description changed\n\* `category_changed` - Category changed\n\* `evidence_added` - Evidence added\n\* `published` - Published'),
  "label": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal'),
  "position": zod.number()
}).strict().nullable(),
  "text": zod.string(),
  "author": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true})
}).strict()),
  "evidence": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "url": zod.string(),
  "fileType": zod.string(),
  "logId": zod.string().uuid().nullable(),
  "uploadedBy": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true})
}).strict())
}).strict()

export const TasksKnowledgeDraftsCreateParams = zod.object({
  "id": zod.string().uuid().describe('UUID of the task.')
})

export const TasksKnowledgeDraftsCreateResponse = zod.object({
  "drafts": zod.array(zod.object({
  "kind": zod.enum(['note', 'decision', 'commitment']).describe('\* `note` - Note\n\* `decision` - Decision\n\* `commitment` - Commitment'),
  "carId": zod.string().uuid().nullable(),
  "content": zod.string()
}).strict())
}).strict()

export const TasksLogsCreateParams = zod.object({
  "id": zod.string().uuid().describe('UUID of the task.')
})

export const tasksLogsCreateBodyTextMax = 8000;



export const TasksLogsCreateBody = zod.object({
  "labelId": zod.string().uuid().nullish(),
  "text": zod.string().min(1).max(tasksLogsCreateBodyTextMax)
})

export const TasksLogsCreateResponse = zod.object({
  "id": zod.string().uuid(),
  "displayId": zod.string(),
  "title": zod.string(),
  "category": zod.enum(['general', 'invoice_dispute', 'maintenance', 'compliance', 'contract', 'performance', 'safety', 'commitment_follow_up']).describe('\* `general` - General\n\* `invoice_dispute` - Invoice dispute\n\* `maintenance` - Maintenance\n\* `compliance` - Compliance\n\* `contract` - Contract\n\* `performance` - Performance\n\* `safety` - Safety\n\* `commitment_follow_up` - Commitment follow-up'),
  "status": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal'),
  "position": zod.number(),
  "kind": zod.enum(['open', 'completed', 'canceled']).describe('\* `open` - Open\n\* `completed` - Completed\n\* `canceled` - Canceled')
}).strict(),
  "propertyId": zod.string().uuid(),
  "propertyName": zod.string(),
  "assignee": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdBy": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "followUpDate": zod.string().date().nullable(),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict()),
  "summary": zod.string(),
  "latestUpdate": zod.object({
  "text": zod.string(),
  "createdAt": zod.string().datetime({"offset":true})
}).strict().nullable(),
  "description": zod.string(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "provider": zod.object({
  "name": zod.string(),
  "contact": zod.string()
}).strict().nullable(),
  "summaryLogCount": zod.number(),
  "substantiveLogCount": zod.number(),
  "publishedAt": zod.string().datetime({"offset":true}).nullable(),
  "publishedLogCount": zod.number(),
  "publishedEntryCount": zod.number(),
  "logs": zod.array(zod.object({
  "id": zod.string().uuid(),
  "kind": zod.enum(['issue_opened', 'update', 'chase_sent', 'provider_update', 'scope_change', 'escalated', 'task_complete', 'resolved', 'status_changed', 'assignee_changed', 'elevators_changed', 'follow_up_changed', 'title_changed', 'description_changed', 'category_changed', 'evidence_added', 'published']).describe('\* `issue_opened` - Issue opened\n\* `update` - Update\n\* `chase_sent` - Chase sent\n\* `provider_update` - Provider update\n\* `scope_change` - Scope change\n\* `escalated` - Escalated\n\* `task_complete` - Task complete\n\* `resolved` - Resolved\n\* `status_changed` - Status changed\n\* `assignee_changed` - Assignee changed\n\* `elevators_changed` - Elevators changed\n\* `follow_up_changed` - Follow-up changed\n\* `title_changed` - Title changed\n\* `description_changed` - Description changed\n\* `category_changed` - Category changed\n\* `evidence_added` - Evidence added\n\* `published` - Published'),
  "label": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal'),
  "position": zod.number()
}).strict().nullable(),
  "text": zod.string(),
  "author": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true})
}).strict()),
  "evidence": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "url": zod.string(),
  "fileType": zod.string(),
  "logId": zod.string().uuid().nullable(),
  "uploadedBy": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true})
}).strict())
}).strict()

export const TasksPublishCreateParams = zod.object({
  "id": zod.string().uuid().describe('UUID of the task.')
})

export const tasksPublishCreateBodyEntriesItemContentMax = 4000;



export const TasksPublishCreateBody = zod.object({
  "entries": zod.array(zod.object({
  "kind": zod.enum(['note', 'decision', 'commitment']).describe('\* `note` - Note\n\* `decision` - Decision\n\* `commitment` - Commitment'),
  "carId": zod.string().uuid().nullish(),
  "content": zod.string().min(1).max(tasksPublishCreateBodyEntriesItemContentMax),
  "supersedesId": zod.string().uuid().nullish(),
  "followUpDate": zod.string().date().nullish()
}))
})

export const TasksPublishCreateResponse = zod.object({
  "created": zod.number(),
  "superseded": zod.number(),
  "followUpTasks": zod.number(),
  "task": zod.object({
  "id": zod.string().uuid(),
  "displayId": zod.string(),
  "title": zod.string(),
  "category": zod.enum(['general', 'invoice_dispute', 'maintenance', 'compliance', 'contract', 'performance', 'safety', 'commitment_follow_up']).describe('\* `general` - General\n\* `invoice_dispute` - Invoice dispute\n\* `maintenance` - Maintenance\n\* `compliance` - Compliance\n\* `contract` - Contract\n\* `performance` - Performance\n\* `safety` - Safety\n\* `commitment_follow_up` - Commitment follow-up'),
  "status": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal'),
  "position": zod.number(),
  "kind": zod.enum(['open', 'completed', 'canceled']).describe('\* `open` - Open\n\* `completed` - Completed\n\* `canceled` - Canceled')
}).strict(),
  "propertyId": zod.string().uuid(),
  "propertyName": zod.string(),
  "assignee": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdBy": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "followUpDate": zod.string().date().nullable(),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict()),
  "summary": zod.string(),
  "latestUpdate": zod.object({
  "text": zod.string(),
  "createdAt": zod.string().datetime({"offset":true})
}).strict().nullable(),
  "description": zod.string(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "provider": zod.object({
  "name": zod.string(),
  "contact": zod.string()
}).strict().nullable(),
  "summaryLogCount": zod.number(),
  "substantiveLogCount": zod.number(),
  "publishedAt": zod.string().datetime({"offset":true}).nullable(),
  "publishedLogCount": zod.number(),
  "publishedEntryCount": zod.number(),
  "logs": zod.array(zod.object({
  "id": zod.string().uuid(),
  "kind": zod.enum(['issue_opened', 'update', 'chase_sent', 'provider_update', 'scope_change', 'escalated', 'task_complete', 'resolved', 'status_changed', 'assignee_changed', 'elevators_changed', 'follow_up_changed', 'title_changed', 'description_changed', 'category_changed', 'evidence_added', 'published']).describe('\* `issue_opened` - Issue opened\n\* `update` - Update\n\* `chase_sent` - Chase sent\n\* `provider_update` - Provider update\n\* `scope_change` - Scope change\n\* `escalated` - Escalated\n\* `task_complete` - Task complete\n\* `resolved` - Resolved\n\* `status_changed` - Status changed\n\* `assignee_changed` - Assignee changed\n\* `elevators_changed` - Elevators changed\n\* `follow_up_changed` - Follow-up changed\n\* `title_changed` - Title changed\n\* `description_changed` - Description changed\n\* `category_changed` - Category changed\n\* `evidence_added` - Evidence added\n\* `published` - Published'),
  "label": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal'),
  "position": zod.number()
}).strict().nullable(),
  "text": zod.string(),
  "author": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true})
}).strict()),
  "evidence": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "url": zod.string(),
  "fileType": zod.string(),
  "logId": zod.string().uuid().nullable(),
  "uploadedBy": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true})
}).strict())
}).strict()
}).strict()

export const TasksSummarizeCreateParams = zod.object({
  "id": zod.string().uuid().describe('UUID of the task.')
})

export const TasksSummarizeCreateResponse = zod.object({
  "id": zod.string().uuid(),
  "displayId": zod.string(),
  "title": zod.string(),
  "category": zod.enum(['general', 'invoice_dispute', 'maintenance', 'compliance', 'contract', 'performance', 'safety', 'commitment_follow_up']).describe('\* `general` - General\n\* `invoice_dispute` - Invoice dispute\n\* `maintenance` - Maintenance\n\* `compliance` - Compliance\n\* `contract` - Contract\n\* `performance` - Performance\n\* `safety` - Safety\n\* `commitment_follow_up` - Commitment follow-up'),
  "status": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal'),
  "position": zod.number(),
  "kind": zod.enum(['open', 'completed', 'canceled']).describe('\* `open` - Open\n\* `completed` - Completed\n\* `canceled` - Canceled')
}).strict(),
  "propertyId": zod.string().uuid(),
  "propertyName": zod.string(),
  "assignee": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdBy": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true}),
  "updatedAt": zod.string().datetime({"offset":true}).nullable(),
  "followUpDate": zod.string().date().nullable(),
  "cars": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict()),
  "summary": zod.string(),
  "latestUpdate": zod.object({
  "text": zod.string(),
  "createdAt": zod.string().datetime({"offset":true})
}).strict().nullable(),
  "description": zod.string(),
  "portfolio": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "provider": zod.object({
  "name": zod.string(),
  "contact": zod.string()
}).strict().nullable(),
  "summaryLogCount": zod.number(),
  "substantiveLogCount": zod.number(),
  "publishedAt": zod.string().datetime({"offset":true}).nullable(),
  "publishedLogCount": zod.number(),
  "publishedEntryCount": zod.number(),
  "logs": zod.array(zod.object({
  "id": zod.string().uuid(),
  "kind": zod.enum(['issue_opened', 'update', 'chase_sent', 'provider_update', 'scope_change', 'escalated', 'task_complete', 'resolved', 'status_changed', 'assignee_changed', 'elevators_changed', 'follow_up_changed', 'title_changed', 'description_changed', 'category_changed', 'evidence_added', 'published']).describe('\* `issue_opened` - Issue opened\n\* `update` - Update\n\* `chase_sent` - Chase sent\n\* `provider_update` - Provider update\n\* `scope_change` - Scope change\n\* `escalated` - Escalated\n\* `task_complete` - Task complete\n\* `resolved` - Resolved\n\* `status_changed` - Status changed\n\* `assignee_changed` - Assignee changed\n\* `elevators_changed` - Elevators changed\n\* `follow_up_changed` - Follow-up changed\n\* `title_changed` - Title changed\n\* `description_changed` - Description changed\n\* `category_changed` - Category changed\n\* `evidence_added` - Evidence added\n\* `published` - Published'),
  "label": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "color": zod.enum(['blue', 'amber', 'green', 'grey', 'red', 'purple', 'teal']).describe('\* `blue` - Blue\n\* `amber` - Amber\n\* `green` - Green\n\* `grey` - Grey\n\* `red` - Red\n\* `purple` - Purple\n\* `teal` - Teal'),
  "position": zod.number()
}).strict().nullable(),
  "text": zod.string(),
  "author": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true})
}).strict()),
  "evidence": zod.array(zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "url": zod.string(),
  "fileType": zod.string(),
  "logId": zod.string().uuid().nullable(),
  "uploadedBy": zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict().nullable(),
  "createdAt": zod.string().datetime({"offset":true})
}).strict())
}).strict()

export const TasksAssigneesListQueryParams = zod.object({
  "property_id": zod.string().uuid().optional().describe('Only people who can access this property.')
})

export const TasksAssigneesListResponseItem = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string()
}).strict()
export const TasksAssigneesListResponse = zod.array(TasksAssigneesListResponseItem)

export const tasksTidyNotesCreateBodyTextMax = 8000;



export const TasksTidyNotesCreateBody = zod.object({
  "text": zod.string().min(1).max(tasksTidyNotesCreateBodyTextMax)
})

export const tasksTidyNotesCreateResponseTextMax = 8000;



export const TasksTidyNotesCreateResponse = zod.object({
  "text": zod.string().max(tasksTidyNotesCreateResponseTextMax)
}).strict()

